<div
  tabindex="0"
  (keydown.enter)="modalService.openVideoModal(videoPreview)"
  (keydown.space)="modalService.openVideoModal(videoPreview)"
  class="video-preview"
  (click)="modalService.openVideoModal(videoPreview)"
>
  <div class="icon-container">
    <svg-icon src="assets/icons/play.svg" [svgStyle]="{ 'width.px': 50, 'height.px': 50 }"></svg-icon>
  </div>
</div>